<template>
    <div class="tag">
        <div class="name">Helix Wongani Chipofya</div>
        <div class="title">
            .NET Full Stack Software Engineer
        </div>
        <div class="main-logo">
  
        </div>
    </div>
</template>
<style scoped>

    .tag{
     display:flex;
     flex-direction: column;
      
    }
    .name, .title{
        font-family:var(--heading);
    }

    .name{
        font-size:1.4rem;
        max-width:13rem;
        margin-bottom:0.3rem;
    }

    .main-logo{
        display: flex;
        justify-content: center;
        margin-top:3rem;
    }

    .logo{
        height:0.4rem;
        
    }

    .title{
        color:var(--gold);
        font-size:0.9rem;
    }
</style>